import { useState, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast"; 
// import { ProgressSpinner } from "primereact/progressspinner";
import { SplitButton } from "primereact/splitbutton"; 
import api from "../../api/axios";
// import { AuthContext } from "../../Context/AuthContext";
import 'primeflex/primeflex.css';

export default function ChangePassword() {
  // const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const toast = useRef(null); 

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (oldPassword === newPassword) {
      setMessage("Old password cannot be used as the new password.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("New password and confirm password do not match.");
      return;
    }

    try {
      setLoading(true); 
      const res = await api.post(
        "/auth/change-password",
        { oldPassword, newPassword },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setMessage(res.data.message || "Password changed successfully.");
      setOldPassword("");
      setNewPassword("");
      setConfirmPassword("");

      toast.current.show({
        severity: 'success',
        summary: 'Password Changed',
        detail: 'Your password has been successfully changed.',
        life: 3000, 
      });

      // logout();
      setTimeout(() => {
        navigate("/dashboard");
      }, 1000);

    } catch (err) {
      setMessage(err.response?.data?.message || "Error changing password.");

      toast.current.show({
        severity: 'error',
        summary: 'Password Change Failed',
        detail: err.response?.data?.message || 'There was an error changing your password.',
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const items = [
    {
      label: "Save",
      icon: "pi pi-check",
      command: handleSubmit,
    }
  ];

  return (
    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1rem",
      }}
    >
      <Toast ref={toast} />

      <Card
        title="Change Password"
        style={{
          width: "100%",
          maxWidth: "500px", 
          padding: "2rem",  
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", 
        }}
      >
        {message && (
          <div
            style={{
              color: message.includes("successfully") ? "green" : "red",
              textAlign: "center",
              marginBottom: "20px",
              fontSize: "16px",
            }}
          >
            {message}
          </div>
        )}

        {/* {loading ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <ProgressSpinner />
          </div>
        ) : ( */}

        <div className="p-d-flex p-jc-center p-ai-center">
          <form onSubmit={handleSubmit} className="p-fluid">
            <div className="p-field p-grid">
              <label htmlFor="oldPassword" className="p-col-12 p-md-3">Old Password</label>
              <div className="p-col-12 p-md-9 mb-4">
                <InputText
                  id="oldPassword"
                  type="password"
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  autoComplete="current-password"
                  className="p-inputtext-sm"
                />
              </div>
            </div>

            <div className="p-field p-grid">
              <label htmlFor="newPassword" className="p-col-12 p-md-3">New Password</label>
              <div className="p-col-12 p-md-9 mb-4">
                <InputText
                  id="newPassword"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  autoComplete="new-password"
                  className="p-inputtext-sm"
                />
              </div>
            </div>

            <div className="p-field p-grid">
              <label htmlFor="confirmPassword" className="p-col-12 p-md-3">Confirm New Password</label>
              <div className="p-col-12 p-md-9 mb-4">
                <InputText
                  id="confirmPassword"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                  className="p-inputtext-sm"
                />
              </div>
            </div>

            <div className="p-field">
              <SplitButton 
                label={loading ? "Changing Password..." : "Change Password"}
                icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                onClick={handleSubmit}
                model={items}
                disabled={loading}
                className=" p-button-block custom-splitbutton"
                // style={{
                //   backgroundColor: "#FC5F1CFF !important",
                //   borderColor: "#FC5F1CFF !important",
                //   color: "#ffffff !important",
                // }}
              />
            </div>
          </form>
        </div>
        {/* )} */}
      </Card>
    </div>
  );
}
